<template>
  <div class="task-list">
    <TableList
      v-rect-loading="loading"
      class="task-list"
      :title="$t(`${i18nPrefix}.template.taskTitle`)"
      :listData="taskList"
      :tableColumns="tableColumns"
      :noAction="true"
      :pagination="pagination"
      @pagination-change="handlePaginationChange"
    >
      <template #executeTime>
        <span class="execute-time-title">{{ $t(`${i18nPrefix}.label.executeTime`) }}</span>
        <span v-auto-tooltip.always="{ content: $t(`${i18nPrefix}.message.executeTime`), placement: 'top', effect: 'dark', popperClass: '' }">
          <i class="el-icon-question"></i>
        </span>
      </template>
      <template #btn>
        <el-button class="create-btn back-btn" @click="handleBack">{{ $t(`${i18nPrefix}.btn.back`) }}</el-button>
      </template>
    </TableList>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import { mapActions } from 'vuex'
import { i18nPrefix } from '@/components/openQuestion/common'

export default {
  components: {
    TableList
  },
  data () {
    return {
      i18nPrefix,
      activeItem: {},
      showDeleteDialog: false,
      listData: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    isEn () {
      return this.$i18n.locale === 'en'
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${i18nPrefix}.label.templateName`),
          dataKey: 'template.title',
          width: 100
        },
        {
          label: this.$t(`${i18nPrefix}.label.updateJobs`),
          dataKey: 'job_name_str',
          width: 200
        },
        {
          label: this.$t(`${i18nPrefix}.label.executeTime`),
          dataKey: 'execute_time',
          headerSlotName: 'executeTime'
        },
        {
          label: this.$t(`${i18nPrefix}.label.finishTime`),
          dataKey: 'finish_time'
        },
        {
          label: this.$t(`${i18nPrefix}.label.executeStatus`),
          dataKey: 'status_label'
        }
      ]
      return columns
    },
    taskList () {
      const taskList = []
      _.forEach(this.listData, (item) => {
        const data = { ...item }
        const jobNameList = []
        if (data.jobs?.job_info?.length > 0) {
          _.forEach(data.jobs.job_info, (jobInfo) => {
            jobNameList.push(this.isEn ? jobInfo.title : jobInfo.cn_title)
          })
        }
        if (jobNameList.length > 0) {
          data.job_name_str = jobNameList.join(', ')
        } else {
          data.job_name_str = ''
        }
        if (data.status === 2 || data.status === '2') {
          data.status_label = this.$t(`${i18nPrefix}.label.taskStatus.success`)
        } else if (data.status === 3 || data.status === '3') {
          data.status_label = this.$t(`${i18nPrefix}.label.taskStatus.failure`)
        } else if (data.status === 1 || data.status === '1') {
          data.status_label = this.$t(`${i18nPrefix}.label.taskStatus.executing`)
        } else {
          data.status_label = this.$t(`${i18nPrefix}.label.taskStatus.pending`)
        }
        data.execute_time = data.execute_time ? moment(data.execute_time).format('YYYY-MM-DD HH:mm') : ''
        data.finish_time = data.finish_time ? moment(data.finish_time).format('YYYY-MM-DD HH:mm') : ''
        taskList.push(data)
      })
      return taskList
    }
  },
  created () {
    this.getTaskList()
  },
  methods: {
    ...mapActions('openQuestion', ['getQuestionUpdateTaskList']),
    async getTaskList () {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        }
        const resp = await this.getQuestionUpdateTaskList(params)
        if (resp && resp.result) {
          this.listData = resp.result
          this.pagination.total = resp.total
        }
      } finally {
        this.loading = false
      }
    },
    handleBack () {
      this.$router.push('/v-admin/open-question/template/management/list')
    },
    handlePaginationChange () {
      this.getTaskList()
    }
  }
}
</script>

<style lang="scss" scoped>
.task-list {
  .execute-time-title {
    padding-right: 4px
  }
}
</style>
